<template>
    <div class="help-card col d6 sm-12">
        <div class="help-card__inner" :style="{background: bg}">
            <div class="help-card__body flex v-center between">
                <div class="help-card__left">
                    <div class="help-card__title" v-if="title">{{ title }}</div>
                    <div class="help-card__text" v-if="text">{{ text }}</div>
                </div>
                <div class="help-card__right">
                    <img v-if="icon" class="help-card__icon" :src="icon" :alt="title">
                </div>
            </div>
            <div class="help-card__action">
                <ABtn :label="btn" :href="action" fill="outlined" class="white"/>
            </div>
        </div>
    </div>
</template>

<script>

import { ABtn } from '../ui'

export default {
    name: 'HelpCard',
    inheritAttrs: false,
    components: {
        ABtn,
    },
    props: {
        bg: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        btn: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        action: {
            type: String,
            default: '',
        },
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss">
    .help-card {
        @include mobile {
            margin-top: 22px;
            &:first-child {
                margin-top: 0;
            }
        }
        &__inner {
            border-radius: var(--br-1);
            padding: 46px;
            color: #fff;
            height: 100%;

            @include tablet {
                padding: 24px;
            }
        }
        &__body {
            @include mobile {
                flex-direction: column-reverse;
                align-items: flex-start;
            }
        }
        &__left {
            padding-right: 10%;
            width: 80%;
            @include mobile {
                margin-top: 15px;
                width: 100%;
                padding-left: 0;
            }
        }
        &__title {
            font-family: var(--font-secondary);
            font-weight: 600;
            line-height: 42px;
            font-size: 32px;

            @include tablet {
                font-size: 22px;
                line-height: 28px;
            }
        }
        &__text {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            margin-top: 24px;

            @include tablet {
                font-size: 14px;
                line-height: 20px;
                margin-top: 14px;
                font-weight: 400;
            }
        }
        &__right {
            display: flex;
            width: 21%;
            justify-content: flex-end;
        }
        &__icon {
            width: 120px;
            @include tablet {
                width: 50px;
            }
        }
        &__action {
            margin-top: 112px;
            @include tablet {
                margin-top: 30px;
            }
            .a-btn {
                min-width: 260px;
                color: #fff;
                @include mobile {
                    width: 100%;
                }
            }
        }
    }
</style>
